import React, { useState } from "react";
import CardImg from "../../../../components/CardImg";

const IMG = `${import.meta.env.BASE_URL}img/cards`;

/**
 * K.B.C card overlay for VideoBox in the reference markup:
 *   .casino-video-cards[.hide-cards] > .casino-cards-shuffle + .casino-video-cards-container
 *     > 5 x <div><span><img></span></div>  (styled by index.css `.kbc .casino-video-cards`).
 * Like the reference: hidden while the first card is a back ("1"); the shuffle handle toggles it.
 */
export default function KbcCardsOverlay({ card }) {
  const [showCards, setShowCards] = useState(true);
  if (!String(card ?? "").length) return null;
  const cards = String(card).split(",").map((c) => c.trim());
  const hidden = !showCards || cards[0] === "1";

  if (cards[0] === "1" && !showCards) setShowCards(true); // new round re-opens a hand-closed strip
  return (
    <div className={`casino-video-cards${hidden ? " hide-cards" : ""}`}>
      <div className="casino-cards-shuffle" onClick={() => cards[0] !== "1" && setShowCards((v) => !v)}>
        <i className="fas fa-grip-lines-vertical" />
      </div>{" "}
      <div className="casino-video-cards-container">
        {[0, 1, 2, 3, 4].map((i) => (
          <React.Fragment key={i}>
            {i > 0 && " "}
            <div>
              <span>
                <CardImg src={`${IMG}/${cards[i] || "1"}.png`} alt="" />
              </span>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
